import PropTypes from 'prop-types';
import css from './ImpersonationHeader.scss';

const ImpersonationHeader = ({impersonationInfo}) => {
    return (
        <div className={css.impersonation}>
            You are impersonating member{' '}
            {impersonationInfo?.impersonatedName
                ?.replace('\\x20', ' ')
                ?.replace('+', ' ')}
        </div>
    );
};

ImpersonationHeader.propTypes = {
    impersonationInfo: PropTypes.shape({
        impersonatedName: PropTypes.string.isRequired,
    }).isRequired,
};

export default ImpersonationHeader;
